import * as React from 'react';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';

interface Props {
  /** HeaderCell elements to render inside the thead */
  children: React.ReactNode;
  /** className for extra styles */
  className?: string;
}

const useStyles = makeStyles({
  tableHead: {
    position: 'relative',
    height: 27
  }
});

/**
 * TableHead: styled Table header row, includes both thead and tr
 */
const TableHead = ({ children, className }: Props) => {
  const classes = useStyles();
  return (
    <thead className={clsx(classes.tableHead, className)}>
      <tr>{children}</tr>
    </thead>
  );
};

export default TableHead;
